import { useCallback, useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import DynamicRender from "../controls/DynamicRender";
import { useHasPermission } from "../../common/Hooks";
import AuditTrail from "../../services/auditTrail";
import Utils from "../../utils/utils";
import Timeline from "./Timeline";

import Toolbar from "../controls/Toolbar";

const AuditTrailView = () => {
    const { id } = useParams();
    const [translate] = useTranslation();
    const [auditTrail, setAuditTrail] = useState([]);
    const [render, setRender] = useState(false);
    const [initiatedBy, setInitiatedBy] = useState({});

    const permissions = useHasPermission({
        domain: Utils.getDomain(),
        environment: null,
        deployment: null,
        type: "auditTrail"
    });

    const getAuditTrail = useCallback(async (id) => {
        setRender(false);
        const response = await AuditTrail.getAuditTrailForASession(id);
        if (!response.error) {
            setAuditTrail(response.data.trail);
            setInitiatedBy(response.data.initiatedBy);
            setRender(true);
        }
    }, [setRender, setAuditTrail, setInitiatedBy]);

    useEffect(() => {
        if (id) {
            getAuditTrail(id);
        }
    }, [id, getAuditTrail]);

    const renderToolbar = useMemo(() => {
        return <Toolbar
            heading={translate("OTM_AUDIT_TRAIL")} />
    }, [translate]);

    const renderAuditTrail = useMemo(() => {
        if (permissions.read) {
            return (
                <DynamicRender render={render}>
                    <div className="card mt-3">
                        <div className="card-header border-bottom">
                            {renderToolbar}
                        </div>
                        <div className="card-body">
                            <div className="p-3 bg-light rounded">
                                <div className="badge bg-primary p-2">{initiatedBy.email}</div>
                                <Timeline data={auditTrail} />
                            </div>
                        </div>
                    </div>
                </DynamicRender>
            );
        }
    }, [permissions.read, auditTrail, render, initiatedBy.email, renderToolbar]);

    return (
        <div style={{ overflowX: 'hidden', overflowY: 'auto' }}>
            {renderAuditTrail}
        </div>
    );
};

export default AuditTrailView;